import React from 'react';
import SectionWrapper from 'components/SubLandingPage/Duo/SectionWrapper';
import SectionHeadline from 'components/SubLandingPage/SectionHeadline';
import LeadParagraph from 'components/SubLandingPage/LeadParagraph';
import { useTranslation } from 'data/translation/useTranslation';
import * as tokens from 'styles';

const PremiumDisplay = () => {
  const { t } = useTranslation();
  return (
    <SectionWrapper>
      {/* eslint-disable @spotify-internal/wtb-rules/no-danger-styled */}
      <SectionHeadline
        paddingBottom={tokens.spacer24}
        dangerouslySetInnerHTML={{
          __html: t('sub_landing_page.pay_nothing_stream_everything'),
        }}
      />
      <LeadParagraph>{t('sub_landing_page.already_paid_for')}</LeadParagraph>
    </SectionWrapper>
  );
};

export default PremiumDisplay;
